// es translations for the buyer payment portal. Generated to mirror
// en.ts keys 1:1; ICU placeholders ({seller}, {qty}, …) preserved verbatim.
// Brand names and financial acronyms (Caratuva, ACH, SEPA, IBAN,
// SWIFT, PIX, CNPJ, CPF, KYC, …) intentionally kept untranslated.
const es: Record<string, string> = {
  'app.name': 'Caratuva',
  'locale.label': 'Idioma',
  'invoice.title': 'Factura de {seller}',
  'invoice.amount.label': 'Importe a pagar',
  'invoice.lineItems.heading': 'Conceptos',
  'invoice.lineItem.qty': 'Cant. {qty} × {unitPrice}',
  'invoice.cta.signin': 'Iniciar sesión para pagar',
  'invoice.cta.continue': 'Continuar para pagar',
  'invoice.dueDate': 'Vence el {date}',
  'invoice.status.label': 'Estado',
  'invoice.error.notFound': 'Factura no encontrada.',
  'signin.heading': 'Iniciar sesión para pagar',
  'signin.subheading':
    'Le enviaremos por correo un enlace de un solo uso. No se requiere contraseña.',
  'signin.email.label': 'Correo electrónico',
  'signin.email.placeholder': 'usted@empresa.com',
  'signin.submit': 'Enviar enlace de inicio de sesión',
  'signin.tos':
    'Al continuar, acepta nuestros <terms>Términos de Servicio</terms> y nuestra <privacy>Política de Privacidad</privacy>.',
  'signin.success.heading': 'Revise su correo',
  'signin.success.body': 'Enviamos un enlace de inicio de sesión. Vence en 15 minutos.',
  'signin.error.emailMismatch': 'Ese correo no coincide con el destinatario de la factura.',
  'signin.session.expired': 'Tu sesión ha expirado. Vuelve a iniciar sesión.',
  'signin.error.generic':
    'No se pudo enviar el enlace de inicio de sesión. Inténtelo de nuevo en un momento.',
  'consume.loading': 'Iniciando su sesión...',
  'consume.error.invalid': 'Este enlace de inicio de sesión no es válido.',
  'consume.error.used': 'Este enlace de inicio de sesión ya se ha utilizado. Solicite uno nuevo.',
  'consume.error.expired': 'Este enlace de inicio de sesión ha vencido. Solicite uno nuevo.',
  'consume.error.generic':
    'No se pudo iniciar su sesión. Solicite un nuevo enlace de inicio de sesión.',
  'consume.cta.requestNew': 'Solicitar un nuevo enlace',
  'kyc.heading': 'Verifique su identidad',
  'kyc.subheading':
    'Complete una verificación de identidad por única vez para que podamos habilitar el on-ramp (entrada de fondos) de esta factura.',
  'kyc.step.entityType': 'Tipo de cuenta',
  'kyc.step.tos': 'Términos del servicio',
  'kyc.step.personal': 'Datos personales',
  'kyc.step.address': 'Domicilio',
  'kyc.step.documents': 'Documentos de identidad',
  'kyc.step.business': 'Datos de la empresa',
  'kyc.step.businessAddress': 'Domicilio de la empresa',
  'kyc.step.owners': 'Beneficiarios finales',
  'kyc.step.businessDocuments': 'Documentos de la empresa',
  'kyc.step.review': 'Revisión',
  'kyc.step.indicator': 'Paso {current} de {total}',
  'kyc.entityType.heading': '¿Está completando esto en su nombre o en el de una empresa?',
  'kyc.entityType.body':
    'Elija la opción que corresponda a quién realiza el pago. Las empresas deben proporcionar documentos de la empresa e información de los beneficiarios finales; las personas físicas solo necesitan su identificación personal.',
  'kyc.entityType.individual': 'Persona física',
  'kyc.entityType.individual.body': 'Usted paga como persona privada, no en nombre de una empresa.',
  'kyc.entityType.business': 'Empresa',
  'kyc.entityType.business.body':
    'Usted paga en nombre de una empresa registrada u otra entidad legal.',
  'kyc.field.legalName.label': 'Razón social',
  'kyc.field.legalName.placeholder': 'Caratuva Inc.',
  'kyc.field.formationDate.label': 'Fecha de constitución',
  'kyc.field.website.label': 'Sitio web de la empresa',
  'kyc.field.website.placeholder': 'https://example.com',
  'kyc.field.businessTaxId.label': 'Identificación fiscal de la empresa',
  'kyc.field.businessTaxId.placeholder': '12-3456789 / 12.345.678/0001-95',
  'kyc.field.businessTaxId.hint': 'EIN (US), CNPJ (BR) o equivalente local.',
  'kyc.field.incorporationDocFile.label': 'Documento de constitución',
  'kyc.field.incorporationDocFile.hint':
    'Acta de constitución, certificado de constitución o equivalente.',
  'kyc.field.proofOfOwnershipDocFile.label': 'Comprobante de titularidad',
  'kyc.field.proofOfOwnershipDocFile.hint':
    'Estructura de capital, registro de titularidad o equivalente que muestre los beneficiarios finales indicados.',
  'kyc.owners.heading': 'Beneficiarios finales',
  'kyc.owners.body':
    'Agregue a cualquier persona que posea el 25% o más de la empresa, o que ejerza un control significativo. Cada titular necesita la misma verificación de identidad que un comprador individual.',
  'kyc.owners.add': 'Agregar otro titular',
  'kyc.owners.remove': 'Eliminar',
  'kyc.owners.title': 'Titular {index}',
  'kyc.owners.role.label': 'Rol',
  'kyc.owners.role.placeholder': 'Seleccione un rol',
  'kyc.owners.role.beneficial_controlling': 'Beneficiario final y persona controladora',
  'kyc.owners.role.beneficial_owner': 'Beneficiario final',
  'kyc.owners.role.controlling_person': 'Persona controladora',
  'kyc.owners.taxType.label': 'Tipo de identificación fiscal (solo US)',
  'kyc.owners.taxType.placeholder': 'Seleccione un tipo de identificación fiscal',
  'kyc.owners.taxType.SSN': 'SSN',
  'kyc.owners.taxType.ITIN': 'ITIN',
  'kyc.owners.proofOfAddress.label': 'Comprobante de domicilio',
  'kyc.owners.proofOfAddress.hint':
    'Documento que muestre el domicilio residencial del beneficiario final (emitido en los últimos 90 días).',
  'kyc.owners.proofOfAddressType.label': 'Tipo de comprobante de domicilio',
  'kyc.owners.proofOfAddressType.placeholder': 'Seleccione un tipo de documento',
  'kyc.owners.proofOfAddressType.UTILITY_BILL': 'Factura de servicios',
  'kyc.owners.proofOfAddressType.BANK_STATEMENT': 'Estado de cuenta bancario',
  'kyc.owners.proofOfAddressType.RENTAL_AGREEMENT': 'Contrato de alquiler',
  'kyc.owners.proofOfAddressType.TAX_DOCUMENT': 'Documento fiscal',
  'kyc.owners.proofOfAddressType.GOVERNMENT_CORRESPONDENCE': 'Correspondencia gubernamental',
  'kyc.tos.heading': 'Acepte los términos del servicio de nuestro socio de liquidación',
  'kyc.tos.body':
    'Se le redirigirá a nuestro socio de liquidación para revisar y aceptar los términos del servicio. Tras la aceptación, lo traeremos de vuelta aquí para continuar.',
  'kyc.tos.cta': 'Continuar a los términos del servicio',
  'kyc.tos.cta.pending': 'Abriendo el socio de liquidación...',
  'kyc.tos.accepted': 'Términos del servicio aceptados.',
  'kyc.tos.required': 'Acepte los términos del servicio antes de continuar.',
  'kyc.tos.error':
    'No se pudo iniciar el flujo de los términos del servicio. Inténtelo de nuevo en un momento.',
  'kyc.field.email.label': 'Correo electrónico',
  'kyc.field.firstName.label': 'Nombre',
  'kyc.field.firstName.placeholder': 'Maria',
  'kyc.field.lastName.label': 'Apellido',
  'kyc.field.lastName.placeholder': 'Silva',
  'kyc.field.dateOfBirth.label': 'Fecha de nacimiento',
  'kyc.field.taxId.label': 'Identificación fiscal',
  'kyc.field.taxId.placeholder': '123-45-6789 / 123.456.789-00',
  'kyc.field.taxId.hint': 'SSN/EIN (US), CPF (BR) o equivalente local.',
  'kyc.field.country.label': 'País de residencia',
  'kyc.field.country.placeholder': 'Seleccione un país',
  'kyc.field.phone.label': 'Teléfono (opcional)',
  'kyc.field.phone.placeholder': '+1 555 123 4567',
  'kyc.field.addressLine1.label': 'Línea de dirección 1',
  'kyc.field.addressLine1.placeholder': 'Calle y número',
  'kyc.field.addressLine2.label': 'Línea de dirección 2 (opcional)',
  'kyc.field.addressLine2.placeholder': 'Apto., suite, unidad',
  'kyc.field.city.label': 'Ciudad',
  'kyc.field.stateProvinceRegion.label': 'Estado / Provincia / Región',
  'kyc.field.postalCode.label': 'Código postal',
  'kyc.field.idDocCountry.label': 'País emisor del documento',
  'kyc.field.idDocType.label': 'Tipo de documento',
  'kyc.field.idDocType.placeholder': 'Seleccione un tipo de documento',
  'kyc.field.idDocType.passport': 'Pasaporte',
  'kyc.field.idDocType.id_card': 'Documento nacional de identidad',
  'kyc.field.idDocType.drivers': 'Licencia de conducir',
  'kyc.field.idDocNumber.label': 'Número de documento (opcional)',
  'kyc.field.selfieFile.label': 'Selfie',
  'kyc.field.selfieFile.hint':
    'Tome una foto clara de su rostro — sin lentes, sin sombrero, bien iluminada. JPG o PNG, máx. 8 MB.',
  'kyc.field.idDocFrontFile.label': 'Documento — anverso',
  'kyc.field.idDocFrontFile.hint':
    'Foto del anverso de su documento, con las cuatro esquinas visibles. JPG o PNG, máx. 8 MB.',
  'kyc.field.idDocBackFile.label': 'Documento — reverso',
  'kyc.field.idDocBackFile.hint':
    'Obligatorio para documentos de identidad y licencias de conducir. JPG o PNG, máx. 8 MB.',
  'kyc.upload.cta': 'Elegir archivo',
  'kyc.upload.replace': 'Reemplazar',
  'kyc.upload.uploading': 'Subiendo...',
  'kyc.upload.uploaded': 'Subido',
  'kyc.upload.error': 'Error al subir. Pruebe con otro archivo.',
  'kyc.upload.unsupported': 'Use JPG, PNG o WebP de menos de 8 MB.',
  'kyc.upload.preview': 'Vista previa',
  'kyc.error.required': 'Este campo es obligatorio.',
  'kyc.error.email': 'Ingrese una dirección de correo electrónico válida.',
  'kyc.error.country': 'Use el código ISO-3166-1 alfa-2 (p. ej. US, BR, FR).',
  'kyc.error.dateOfBirth': 'Ingrese una fecha de nacimiento válida.',
  'kyc.error.minor': 'Debe tener 18 años o más.',
  'kyc.error.generic':
    'No se pudo iniciar su verificación de identidad. Vuelva a intentarlo en un momento.',
  'kyc.review.heading': 'Verificación de identidad enviada',
  'kyc.review.body':
    'Su verificación de identidad está en revisión. Le enviaremos un correo electrónico cuando se haya procesado.',
  'kyc.review.cta': 'Ver estado del pago',
  'kyc.review.summary.heading': 'Revise su información',
  'kyc.review.summary.body':
    'Tómese un momento para confirmar que todo esté correcto. Una vez enviada, no puede editar una solicitud de KYC — tendría que iniciar una nueva.',
  'kyc.submit': 'Enviar verificación de identidad',
  'kyc.submit.pending': 'Enviando...',
  'kyc.next': 'Continuar',
  'kyc.back': 'Atrás',
  'kyc.status.label': 'Estado',
  'kyc.status.verifying': 'En revisión',
  'kyc.status.approved': 'Aprobado',
  'kyc.status.rejected': 'Rechazado',
  'kyc.status.notStarted': 'No iniciado',
  'kyc.hosted.cta': 'Continuar al proveedor de identidad',
  'onramp.heading': 'Elija cómo desea pagar',
  'onramp.subheading':
    'Fijamos una cotización de cambio (FX) durante 10 minutos una vez que seleccione un método.',
  'onramp.method.ach': 'ACH (transferencia bancaria de EE. UU.)',
  'onramp.method.wire': 'Transferencia wire',
  'onramp.method.sepa': 'SEPA (transferencia bancaria de la UE)',
  'onramp.method.card': 'Tarjeta',
  'onramp.method.label': 'Método de financiación',
  'onramp.targetCurrency.label': 'Moneda que enviará',
  'onramp.targetCurrency.helper':
    'Convertimos a la tasa fijada cuando llegan los fondos. Hágala coincidir con la cuenta desde la que envía.',
  'onramp.quote.locked': 'Cotización fijada. Vence el {expires}.',
  'onramp.quote.expired': 'La cotización venció. Actualice para fijar una nueva.',
  'onramp.quote.refresh': 'Actualizar cotización',
  'onramp.cta.lockQuote': 'Fijar cotización de cambio (FX)',
  'onramp.cta.confirm': 'Confirmar y obtener las instrucciones',
  'onramp.cta.confirm.pending': 'Enviando...',
  'onramp.error.generic':
    'No se pudo iniciar el on-ramp (entrada de fondos). Inténtelo de nuevo en un momento.',
  'onramp.instructions.heading': 'Envíe su pago',
  'onramp.instructions.subheading':
    'Esta cuenta es exclusiva de su factura: envíe el importe exacto y emparejamos su transferencia automáticamente.',
  'onramp.instructions.bank': 'Banco',
  'onramp.instructions.accountName': 'Nombre de la cuenta',
  'onramp.instructions.accountNumber': 'Número de cuenta',
  'onramp.instructions.routing': 'Número de ruta (routing)',
  'onramp.instructions.iban': 'IBAN',
  'onramp.instructions.swift': 'SWIFT / BIC',
  'onramp.instructions.reference': 'Código de referencia',
  'onramp.instructions.memo': 'Concepto / memo',
  'onramp.instructions.copy': 'Copiar',
  'onramp.instructions.copied': 'Copiado',
  'onramp.instructions.continue': 'Hacer seguimiento de este pago',
  'onramp.instructions.empty':
    'Aún no se han devuelto instrucciones bancarias. Se las enviaremos por correo electrónico cuando estén listas.',
  'tracking.heading': 'Seguimiento del pago',
  'tracking.placeholder':
    'Las pantallas de KYC, método de financiación y on-ramp (entrada de fondos) llegarán en próximos PRs.',
  'tracking.cta.back': 'Volver a la factura',
  'tracking.cta.startOnRamp': 'Continuar para pagar',
  'tracking.refreshing': 'Consultando actualizaciones...',
  'tracking.timeline.heading': 'Progreso',
  'tracking.step.invoice': 'Factura recibida',
  'tracking.step.kyc': 'Verificación de identidad completada',
  'tracking.step.onramp': 'On-ramp (entrada de fondos) iniciado',
  'tracking.step.fiat': 'Fondos recibidos',
  'tracking.step.offramp': 'Off-ramp (salida de fondos) iniciado',
  'tracking.step.settled': 'Liquidado en BRL',
  'tracking.alert.kycRejected.heading': 'Verificación de identidad rechazada',
  'tracking.alert.kycRejected.body':
    'No se pudo aprobar su verificación de identidad. Vuelva a enviarla con datos actualizados.',
  'tracking.alert.kycRejected.cta': 'Reenviar verificación de identidad',
  'tracking.alert.kycPending.heading': 'Verificación de identidad en revisión',
  'tracking.alert.kycPending.body':
    'Estamos a la espera del proveedor de verificación. Le enviaremos un correo cuando finalice.',
  'tracking.alert.underpayment.heading': 'Pago insuficiente detectado',
  'tracking.alert.underpayment.body':
    'El importe que recibimos es menor que el de la factura. Contacte con soporte para conciliarlo.',
  'tracking.alert.contactSupport': 'Contactar con soporte',
  'tracking.alert.expired.heading': 'Factura vencida',
  'tracking.alert.expired.body':
    'Esta factura ha vencido. Solicite al vendedor que emita una nueva.',
  'tracking.alert.cancelled.heading': 'Factura cancelada',
  'tracking.alert.cancelled.body': 'El vendedor canceló esta factura.',
  'common.loading': 'Cargando...',
  'common.retry': 'Reintentar',
};
export default es;
